<template>
  <v-container v-if="visible">
    <v-card>
      <v-card-text>
        <v-container>
          <v-layout d-block>
            <v-flex>
              <v-select
                  :value="activeAddress.job"
                  :items="jobs"
                  @input="updateJob"
                  label="Uit te voeren werkzaamheden"></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="closeForm" color="primary">Sluiten</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {configurationService} from "@/services/admin";

export default {
  name: "job-update",
  props: ["visible"],
  data: () => ({
    job: null,
    jobs: [],
  }),
  computed: {
    ...mapGetters(["activeAddress"])
  },
  methods: {
    ...mapActions(["saveJob"]),
    closeForm() {
      this.$parent.closeUpdateJobForm();
    },
    resolveJobs() {
      configurationService.listJobs().then(result => {
        this.jobs = result.data.map(e => e.name);
      });
    },
    updateJob(job) {
      this.saveJob(job);
    }
  },
  created() {
    this.resolveJobs();
  }
}
</script>